var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "평가대상 목록 - 작업/작업단계/유해위험요인",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.process.sops,
                merge: _vm.grid.merge,
                columnSetting: false,
                expandAll: false,
                isFullScreen: false,
                usePaging: false,
                hideBottom: true,
                filtering: false,
                editable: _vm.editable && !_vm.disabled && _vm.isSelect,
                selection: "multiple",
                rowKey: "ramJsaAssessScenarioId",
              },
              on: { innerBtnClicked: _vm.innerBtnClicked },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "customCol"
                        ? [
                            _c(
                              "q-chip",
                              {
                                staticStyle: {
                                  "margin-bottom": "4px !important",
                                },
                                attrs: {
                                  color: "amber",
                                  clickable: true,
                                  "text-color": "white",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return (() => {
                                      _vm.rowClick(props.row, props.pageIndex)
                                    }).apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v(" 수정 ")]
                            ),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-chip",
                    {
                      staticClass: "q-ml-sm",
                      staticStyle: {
                        height: "26px",
                        "margin-right": "2px !important",
                      },
                      attrs: {
                        square: "",
                        clickable: "",
                        size: "md",
                        color: "light-green-8",
                        "text-color": "white",
                        icon: "contact_support",
                        label: "범례",
                      },
                    },
                    [
                      _c(
                        "q-popup-proxy",
                        [
                          _c(
                            "q-banner",
                            [
                              _c("q-chip", { attrs: { color: "green" } }),
                              _vm._v(" 작업단계추가 "),
                            ],
                            1
                          ),
                          _c("q-separator", { attrs: { inset: "" } }),
                          _c(
                            "q-banner",
                            [
                              _c("q-chip", { attrs: { color: "lime" } }),
                              _vm._v(" 유해위험요인추가 "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.editable && !_vm.disabled && _vm.isSelect,
                            expression: "editable&&!disabled&&isSelect",
                          },
                        ],
                        attrs: { label: "추가", icon: "add" },
                        on: { btnClicked: _vm.addJob },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.editable &&
                              !_vm.disabled &&
                              _vm.isSelect &&
                              _vm.checkProcessCd,
                            expression:
                              "editable&&!disabled&&isSelect&&checkProcessCd",
                          },
                        ],
                        attrs: { label: "SOP 추가", icon: "add" },
                        on: { btnClicked: _vm.openSop },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false",
                          },
                        ],
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.sopScenarioSave,
                          mappingType: "PUT",
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveSop,
                          btnCallback: _vm.saveSopCallback,
                        },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.editable && !_vm.disabled && _vm.isSelect,
                            expression: "editable&&!disabled&&isSelect",
                          },
                        ],
                        attrs: { label: "삭제", icon: "remove" },
                        on: { btnClicked: _vm.removeSop },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.sopDialog,
            callback: function ($$v) {
              _vm.sopDialog = $$v
            },
            expression: "sopDialog",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { "min-width": "350px" } },
            [
              _c(
                "q-form",
                { ref: "editForm" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "작업/작업단계/유해위험요인 추가" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.editable &&
                                      !_vm.disabled &&
                                      _vm.isSelect &&
                                      _vm.isRowClick,
                                    expression:
                                      "editable&&!disabled&&isSelect&&isRowClick",
                                  },
                                ],
                                attrs: {
                                  disabled: _vm.disabledSop,
                                  label: "저장",
                                  icon: "save",
                                },
                                on: { btnClicked: _vm.accepts },
                              }),
                              _c("c-btn", {
                                attrs: { label: "닫기", icon: "cancel" },
                                on: { btnClicked: _vm.closeDialog },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: true,
                                label: "공정",
                                name: "processName",
                              },
                              model: {
                                value: _vm.sop.processName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sop, "processName", $$v)
                                },
                                expression: "sop.processName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled:
                                  _vm.disabledSop ||
                                  _vm.disabled1 ||
                                  !_vm.isRowClick,
                                required: true,
                                label: "작업",
                                name: "jobName",
                              },
                              on: { dataChange: _vm.jobChange },
                              model: {
                                value: _vm.sop.jobName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sop, "jobName", $$v)
                                },
                                expression: "sop.jobName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled:
                                  _vm.disabledSop ||
                                  _vm.disabled2 ||
                                  !_vm.isRowClick,
                                required: true,
                                label: "작업단계순번",
                                name: "jobStepNo",
                              },
                              on: { dataChange: _vm.jobStepChange },
                              model: {
                                value: _vm.sop.jobStepNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sop, "jobStepNo", $$v)
                                },
                                expression: "sop.jobStepNo",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled:
                                  _vm.disabledSop ||
                                  _vm.disabled2 ||
                                  !_vm.isRowClick,
                                required: true,
                                label: "작업단계",
                                name: "jobStepName",
                              },
                              on: { dataChange: _vm.jobStepChange },
                              model: {
                                value: _vm.sop.jobStepName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sop, "jobStepName", $$v)
                                },
                                expression: "sop.jobStepName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled:
                                  _vm.disabledSop ||
                                  _vm.disabled2 ||
                                  !_vm.isRowClick,
                                required: true,
                                label: "작업단계설명",
                                name: "jobStepDesc",
                              },
                              on: { dataChange: _vm.jobStepChange },
                              model: {
                                value: _vm.sop.jobStepDesc,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sop, "jobStepDesc", $$v)
                                },
                                expression: "sop.jobStepDesc",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                afterIcon:
                                  _vm.editable &&
                                  !_vm.disabledSop &&
                                  !_vm.disabled3 &&
                                  _vm.isRowClick
                                    ? [
                                        {
                                          name: "search",
                                          click: true,
                                          callbackName: "searchRiskHazard",
                                          color: "teal",
                                        },
                                        {
                                          name: "close",
                                          click: true,
                                          callbackName: "removeRiskHazard",
                                          color: "red",
                                        },
                                      ]
                                    : null,
                                editable: _vm.editable,
                                disabled:
                                  _vm.disabledSop ||
                                  _vm.disabled3 ||
                                  !_vm.isRowClick,
                                required: true,
                                label: "유해위험요인",
                                name: "riskHazardNameClass",
                              },
                              on: {
                                searchRiskHazard: _vm.searchRiskHazard,
                                removeRiskHazard: _vm.removeRiskHazard,
                                dataChange: _vm.chagneRiskHazard,
                              },
                              model: {
                                value: _vm.sop.riskHazardNameClass,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sop, "riskHazardNameClass", $$v)
                                },
                                expression: "sop.riskHazardNameClass",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }